var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            disabled: _vm.disabled,
            clearable: "",
            filterable: "",
            placeholder: "Country",
            name: "country",
          },
          model: {
            value: _vm.countryCode,
            callback: function ($$v) {
              _vm.countryCode = $$v
            },
            expression: "countryCode",
          },
        },
        _vm._l(_vm.countryMap, function (country, _sname) {
          return _c(
            "el-option",
            { key: _sname, attrs: { value: _sname, label: country.name } },
            [
              _c("span", { staticStyle: { float: "left" } }, [
                _vm._v(_vm._s(country.name)),
              ]),
              _vm._v(" "),
              _c("span", { staticStyle: { float: "right", color: "#999" } }, [
                _vm._v(_vm._s(_vm._f("uppercase")(_sname))),
              ]),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }